<template>

    <trax-ui-ajax-simple-table 
        :id="id" :header="header" :header-color="headerColor" :titles="titles"
        :endpoint="endpoint" :rows="rows" :cols="cols" :bus="bus">
    </trax-ui-ajax-simple-table>
    
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-learner-registrations' },
            header: { default: 1 },
            headerColor: { default: 'primary' },
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                learner: data.learner,
                registration_id: data.registration_id,
                status_select: data.status_select,
                endpoint: app_url+"polaris/api/front/dashboard/learners/"+data.learner.id+"/registrations",
                titles: [
                    lang.polaris.training.program,
                    lang.polaris.account.group,
                    lang.polaris.form.status,
                    lang.polaris.dashboard.progress,
                ],
                cols: [
                    {},
                    {},
                    {class: 'text-center'},
                    {class: 'text-center'},
                ],
                rows: [],
                registrations : null,
                bus: new Vue()
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
        },
        
        updated: function() {
            $("#"+this.id+"-table .peity.donut").peity("donut");
        },
        
        methods: {
        
            setData(data) {
                this.registrations = data.data;
                this.rows = [];
                for (var index in this.registrations) {
                    var registration = this.registrations[index];
                    this.rows.push([
                        this.program(registration),
                        this.group(registration),
                        this.status(registration),
                        this.progress(registration),
                    ]);
                }
            },

            // Columns rendering

            program(row) {
                return this.link(row, row.program.name);
            },

            group(row) {
                return this.link(row, row.cohort.name, true);
            },

            status(row) {

                // Registration status
                var status_code = row.status;
                var label = this.status_select.find(status => status.value == row.status).name
                var color = 'info';
                if (status_code == 'active') color = 'success';
                else if (status_code == 'maintenance') color = 'warning';
                else if (status_code == 'archived') color = 'default';

                // Group or program maintenance 
                if (status_code == 'active' && (row.cohort.status == 'maintenance' || row.program.status == 'maintenance')) {
                    status_code = 'maintenance';
                    label = this.lang.polaris.options.maintenance;
                    color = 'warning';
                }

                // HTML
                var html = '<span class="badge badge-'+color+'">'+label+'</span>';
                return this.link(row, html);
            },

            progress(row) {
                var state = row.state;
                if (!state) return '';
                var html = '<div class="mt-1">';
                html += '<span class="peity donut" data-peity=\'{ "fill": ["#00acc1", "#eeeeee"], "innerRadius": 10, "radius": 12 }\'>';
                html += state.completion.percent + '/100</span>';
                html += '<small class="ml-1">'+state.completion.percent+'%</small>';
                if (state.cancelled) {
                    html += '<br><span class="badge badge-danger">Terminated</span>'
                }
                html += '</div>';
                return this.link(row, html);
            },

            link(row, content, light) {

                // Accessibility
                if (!row.accessible) return content;

                // Check if there is a link
                var status_code = row.status;
                if (status_code == 'active' && (row.cohort.status == 'maintenance' || row.program.status == 'maintenance')) {
                    status_code = 'maintenance';
                }

                // No link for maintenance items, when appropriated permission
                var link = true;
                if (status_code == 'maintenance') {
                    link = this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations']
                        || this.user.permissions['dashboard.read-all'] || this.user.permissions['dashboard.read-mine-locations']
                        || this.user.permissions['registration.manage'];
                }

                // No link
                if (!link) return content;

                // Build the link
                var routes = window.data.program_dashboard_routes;
                var href = routes[row.program.type]+'/registration/'+row.id+'/learner/'+this.learner.id;
                var myclass = '';
                if (light) myclass = ' class="trax-text-light" ';
                return '<a href="'+href+'" '+myclass+'>'+content+'</a>';
            }
        }
    }
</script>
